module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "SitePage"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin": "auto",
      "text-align": "left"
    },
    model: {
      value: (_vm.getVersionInfo),
      callback: function($$v) {
        _vm.getVersionInfo = $$v
      },
      expression: "getVersionInfo"
    }
  }, [_c('div', [_c('help', {
    attrs: {
      "reflink": "userguide",
      "label": "User guide"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_vm._v("Please copy and paste the table below into your email, along with any error messages.")])], 1), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped table-hover"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "tlabel"
  }, [_vm._v("Username    ")]), _c('td', [_vm._v(_vm._s(_vm.username))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tlabel"
  }, [_vm._v("Browser     ")]), _c('td', [_vm._v(_vm._s(_vm.useragent))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tlabel"
  }, [_vm._v("App version ")]), _c('td', [_vm._v("Optima Nutrition " + _vm._s(_vm.version) + " (" + _vm._s(_vm.date) + ") [" + _vm._s(_vm.gitbranch) + "/" + _vm._s(_vm.githash) + "]")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tlabel"
  }, [_vm._v("Timestamp   ")]), _c('td', [_vm._v(_vm._s(_vm.timestamp))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tlabel"
  }, [_vm._v("Server name ")]), _c('td', [_vm._v(_vm._s(_vm.server))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tlabel"
  }, [_vm._v("Server load ")]), _c('td', [_vm._v(_vm._s(_vm.cpu))])])])]), _vm._v(" "), _c('div', [_c('button', {
    on: {
      "click": _vm.adv_consoleModal
    }
  }, [(!_vm.adv_showConsole) ? _c('span', [_vm._v("Developer options")]) : _vm._e(), _vm._v(" "), (_vm.adv_showConsole) ? _c('span', [_vm._v("Hide developer options")]) : _vm._e()])]), _vm._v(" "), (_vm.adv_showConsole) ? _c('div', [_c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "controls-box"
  }, [_c('b', [_vm._v("Token")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adv_authentication),
      expression: "adv_authentication"
    }],
    staticClass: "txbox",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.adv_authentication)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.adv_authentication = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('b', [_vm._v("Query")]), _c('br'), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adv_query),
      expression: "adv_query"
    }],
    attrs: {
      "rows": "10",
      "cols": "100"
    },
    domProps: {
      "value": (_vm.adv_query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.adv_query = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.adv_submit
    }
  }, [_vm._v("Submit")]), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("Output")]), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.adv_response)
    }
  })])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("For assistance from the Optima team, please email "), _c('a', {
    attrs: {
      "href": "mailto:help@ocds.co"
    }
  }, [_vm._v("help@ocds.co")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "100"
    }
  }, [_vm._v("Technical information")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-90dadfa2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/HelpPage.vue
// module id = 392
// module chunks = 1